<template>
    <div v-if="hasColumns && hasFields" class="bg-light rounded border m-1 p-1">
        <span v-for="field in fields">
            <i class="fad me-2 text-primary" :class="getClass(field.value)"> </i>
            {{field.value.name}}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'RowFieldDisplay',
        props: ['row', 'prop2'],
        computed: {
            hasColumns() {
                return this.row.columns && this.row.columns.length > 0
            },
            hasFields() {
                return this.hasColumns && this.fields && this.fields.length > 0
            },
            column() {
                return this.row.columns[0]
            },
            fields() {
                return this.column.value
            }
        },
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            getClass(field) {
                return webase.utils.ui.getClass(field)
            }
        }
    }
</script>

<style>

</style>
